// extracted by mini-css-extract-plugin
export var poemDate = "poem-module--poem-date--nu7nU";
export var poemText = "poem-module--poem-text--s-xd2";
export var poemTitle = "poem-module--poem-title--L6EFT";